import { render, staticRenderFns } from "./guessing-bet.vue?vue&type=template&id=0326b80e&scoped=true&"
import script from "./guessing-bet.vue?vue&type=script&lang=js&"
export * from "./guessing-bet.vue?vue&type=script&lang=js&"
import style0 from "./guessing-bet.vue?vue&type=style&index=0&id=0326b80e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0326b80e",
  null
  
)

export default component.exports